angular.module('filters').filter('formatDate', ["$filter", function($filter) {
  return function(input) {
    if (input) {
      return $filter('date')(input, 'longDate');
    }
  };
}]);
